<adapt-toolbar-inactive [entity]="person"
                        type="person"> </adapt-toolbar-inactive>

@if (hasEditPermission) {
    <div adaptToolbarContent>
        <button adaptButtonIcon="add"
                (click)="recordCareerValuation()"
                data-test="record-new-button">Record new</button>
        @if (currentValuation) {
            <button adaptButtonIcon="edit"
                    [adaptBlockingClick]="editCareerValuation"
                    data-test="edit-latest-button">Edit latest</button>
        }
    </div>
}
<adapt-two-column-page>
    <div left-column>
        <adapt-dashboard-element #currentCVTDashboardElement
                                 name="{{ fullName }} Career Valuation"
                                 data-test="view-latest-career-valuation">
            <div *adaptLoading="isLoading">
                @if (!currentValuation) {
                    <div>No Career Valuation has been recorded.</div>
                }
                @if (currentValuation) {
                    <div>
                        <adapt-cvt-personal-summary [careerValuation]="currentValuation"> </adapt-cvt-personal-summary>
                        @if (currentValuation.links?.length) {
                            <div class="my-3">
                                <label>Associated actions</label>
                                @for (link of currentValuation.links; track link) {
                                    <adapt-display-action-link [link]="link"
                                                               [itemLinksDisabled]="true"> </adapt-display-action-link>
                                }
                            </div>
                        }
                        <adapt-cultural-measurement-meta [culturalEntity]="currentValuation"
                                                         [showCulturalLeaderData]="true"
                                                         data-test="cultural-measurement-metadata"> </adapt-cultural-measurement-meta>
                    </div>
                }
            </div>
        </adapt-dashboard-element>
    </div>
    <div right-column>
        @if (currentValuation) {
            <adapt-dashboard-element name="{{ fullName }} Career Valuation history">
                <button adapt-dashboard-title-buttons
                        class="btn btn-primary btn-pill"
                        adaptButtonIcon="fal fa-download"
                        (click)="onClickExport()"
                        data-test="export-data-button">Export data</button>
                <adapt-cvt-history [personId]="person?.personId"
                                   data-test="career-valuation-history"> </adapt-cvt-history>
            </adapt-dashboard-element>
        }
    </div>
</adapt-two-column-page>
